export enum ContentIds {
  Popular = 'popular',
  ProductSuggestion = 'suggestion product',
  BrandSuggestion = 'suggestion brand',
}
